<template>
<div class="payments">
  <v-card class="payments">
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>Płatność</v-toolbar-title>
    </v-toolbar>
    <v-layout justify-center row>
    <v-flex
      xs12
      sm10
      md8
      lg6
      xl4>
    <v-list>
      <v-list-tile @click="">
                <v-layout justify-space-between row wrap>
                  <v-flex xs12 sm6 class="d-inline-block">
                    Za okres
                  </v-flex>
                  <v-flex xs12 sm6 class="text-sm-right d-inline-block">
                    {{payment.period | formatDate('MMMM YYYY')}}
                  </v-flex>
                </v-layout>
      </v-list-tile>
      <v-divider />
      <v-list-tile @click="">
                <v-layout justify-space-between row wrap>
                  <v-flex xs12 sm6 class="d-inline-block">
                    Kwota
                  </v-flex>
                  <v-flex xs12 sm6 class="text-sm-right d-inline-block">
                    {{ payment.price }} PLN
                  </v-flex>
                </v-layout>
      </v-list-tile>
      <v-divider />
      <v-list-tile @click="">
                <v-layout justify-space-between row wrap>
                  <v-flex xs12 sm6 class="d-inline-block">
                    Termin płatności
                  </v-flex>
                  <v-flex xs12 sm6 class="text-sm-right d-inline-block">
                    {{ payment.due_date | formatDate('LL')}}
                  </v-flex>
                </v-layout>
      </v-list-tile>
    </v-list>
    </v-flex>
    </v-layout>
    <v-layout justify-center row>
    <v-flex
      xs12
      sm10
      md10
      lg10 xl6>
    <v-layout justify-space-between row wrap class="mb-4">
      <v-flex xs12 sm6 class="d-inline-block payment-method-left">
        <div class="payment-header">
          Przelew online
        </div>
        <div class="payment-content left">
          <div class="payment-logo"><img src="@/assets/img/dotpay_logo.png" /></div>
          <v-btn color="primary" @click="pay">Zapłać</v-btn>
          <form ref="form" method="POST" :action="dotpay.gateway_url">
            <input type="hidden" name="id" :value="dotpay.id" />
            <input type="hidden" name="firstname" :value="dotpay.firstname" />
            <input type="hidden" name="lastname" :value="dotpay.lastname" />
            <input type="hidden" name="email" :value="dotpay.email" />
            <input type="hidden" name="currency" :value="dotpay.currency" />
            <input type="hidden" name="amount" :value="dotpay.amount" />
            <input type="hidden" name="description" :value="dotpay.description" />
            <input type="hidden" name="type" :value="dotpay.type" />
            <input type="hidden" name="URL" :value="dotpay.URL" />
            <input type="hidden" name="URLC" :value="dotpay.URLC" />
            <input type="hidden" name="control" :value="dotpay.control" />
            <input type="hidden" name="chk" :value="dotpay.chk" />
          </form>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="d-inline-block">
        <div class="payment-header">
          Zapłać przelewem tradycyjnym
        </div>
        <div class="payment-content">
          <table>
            <tr>
              <th>Nr konta</th>
              <td>70 1140 2004 0000 3702 7603 4279</td>
            </tr>
            <tr>
              <th>Nazwa odbiorcy</th>
              <td>Inżynieria Biegania Dawid Malina</td>
            </tr>
            <tr>
              <th>Adres odbiorcy</th>
              <td>ul. ks. Konrada Szwedy 7B/10<br/>44-207 Rybnik</td>
            </tr>
            <tr>
              <th>Tytułem</th>
              <td>Płatność {{ payment.id }}</td>
            </tr>
          </table>
        </div>
      </v-flex>
    </v-layout>


    </v-flex>
    </v-layout>
  </v-card>

</div>
</template>

<script>
import {fetchRunnerPayment, payRunnerPayment} from './api'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      payment: {},
      dotpay: {}
    }
  },
  computed: {
    ...mapState(['runner'])
  },
  created () {
    this.fetchPayment()
  },
  watch: {
    '$route': 'fetchPayment'
  },
  methods: {
    fetchPayment () {
      fetchRunnerPayment(this.runner, this.$route.params.payment_id).then((payment) => {
        this.payment = payment
      })
    },
    pay () {
      payRunnerPayment(this.runner, this.payment).then((data) => {
        this.dotpay = data
        this.$nextTick().then(() => {
          this.$refs.form.submit()
        })
      })
    }
  }
}
</script>
<style>
.payment-header {
  text-align: center;
  background-color: #ddd;
  border-radius: 2px 2px 0px 0px;
}
@media(min-width: 600px) {
  .payment-method-left {
    border-right: solid 2px #80cbc4;
  }
}
.payment-content {
  padding: 10px;
}
.payment-content th {
  padding: 0px 10px;
}
.payment-content.left {
  height: 90%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.payment-logo img {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/payments/RunnerPaymentPay.vue